import { styled } from '../../../common/ui'
import { theme } from '../theme'

export const Page = styled.div`
  margin: 0;
  padding: 0;
  font-family: ${theme.fonts.text};
  background: #fff;
`
